import Marquee from "react-fast-marquee";
import { SUPPORTED_COINS } from "@/lib/constants";

export default function SupportedCoins() {
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="supported-coins-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.2em] text-[#3B6FBF] font-bold mb-4">
            Supported assets
          </div>
          <h2 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-[1.05] text-slate-900" data-testid="supported-coins-title">
            Convert USDT and BTC —<br />we'll handle it in record time.
          </h2>
          <p className="mt-5 text-slate-600 max-w-md">
            Trade USDT and BTC across multiple blockchain networks — Tron (TRC-20) and BEP-20 — with many more digital assets coming soon.
          </p>
        </div>
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
        <Marquee speed={45} pauseOnHover gradient={false}>
          {SUPPORTED_COINS.concat(SUPPORTED_COINS).map((c, i) => (
            <div
              key={i}
              className="mx-3 inline-flex items-center gap-3 px-5 py-3 rounded-full border border-slate-200 bg-white hover:border-[#3B6FBF]/40 hover:shadow-sm transition-all"
              data-testid={`coin-chip-${c.sym.toLowerCase()}`}
            >
              <span
                className="w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-bold text-white"
                style={{ background: c.color }}
              >
                {c.sym.slice(0, 2)}
              </span>
              <span className="text-sm font-semibold text-slate-900">{c.name}</span>
              <span className="font-mono-data text-xs text-slate-500">{c.sym}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
